import React, { useEffect } from "react";
import Footer from "../shared/Footer/Footer";
import Navbar from "../shared/Navbar/Navbar";
import "../../style/donation.css";
import TranslateButton from "../TranslateButton/TranslateButton";

const Donation = () => {
  useEffect(() => {
    document.title = `Development Concern | Donation`;
  }, []);

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="donation_section">
        <div className="container">
          <div className="bank_information">
            <h4>Donation Information</h4>
            <p>
              <b>Bank Name :</b> Sonali Bank, Banarupa Branch, Rangamati
            </p>
            <p>
              <b>Account Name :</b> Development Concern
            </p>
            <p>
              <b>Account No :</b> 4079
            </p>
            <p>
              <b>Branch Code :</b> 007
            </p>
            <p>
              <b>Routing No :</b> 200840073
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Donation;
